import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useSiteSettings } from "@/lib/siteSettings";

const BULB_COLORS = ["#d62828", "#f4c430", "#2a9d4b", "#4aa3df", "#f77f00"];

const Garland = () => {
  const bulbs = Array.from({ length: 40 }, (_, i) => i);
  return (
    <div className="xmas-garland" aria-hidden="true" data-testid="xmas-garland">
      {bulbs.map((i) => (
        <span
          key={i}
          className="xmas-bulb"
          style={{
            "--bulb": BULB_COLORS[i % BULB_COLORS.length],
            animationDelay: `${(i % 7) * 0.35}s`,
          }}
        />
      ))}
    </div>
  );
};

const Snow = () => {
  const flakes = useMemo(
    () =>
      Array.from({ length: 28 }, (_, i) => ({
        left: Math.random() * 100,
        size: 4 + Math.random() * 6,
        duration: 9 + Math.random() * 10,
        delay: -Math.random() * 18,
        drift: (Math.random() - 0.5) * 80,
        opacity: 0.35 + Math.random() * 0.45,
        hideMobile: i % 2 === 1,
      })),
    []
  );
  return (
    <div className="xmas-snow" aria-hidden="true" data-testid="xmas-snow">
      {flakes.map((f, i) => (
        <span
          key={i}
          className={`xmas-flake ${f.hideMobile ? "hidden md:block" : ""}`}
          style={{
            left: `${f.left}%`,
            width: f.size,
            height: f.size,
            opacity: f.opacity,
            animationDuration: `${f.duration}s`,
            animationDelay: `${f.delay}s`,
            "--drift": `${f.drift}px`,
          }}
        />
      ))}
    </div>
  );
};

// Site-wide Christmas mode: lights garland + light snowfall, toggled from admin.
export const ChristmasDecorations = () => {
  const settings = useSiteSettings();
  const { pathname } = useLocation();
  const active = !!settings?.christmas_theme && !pathname.startsWith("/admin");

  useEffect(() => {
    document.body.classList.toggle("theme-christmas", active);
    return () => document.body.classList.remove("theme-christmas");
  }, [active]);

  if (!active) return null;
  return (
    <>
      <Garland />
      <Snow />
    </>
  );
};

export default ChristmasDecorations;
